import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DownloadService } from '../../services/downloads/download.service';
import { UtilsService } from '../../services/utils/utils.service';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';
import { NgFor, NgIf, NgStyle } from '@angular/common';
@Component({
    selector: 'app-ltms-download-widget',
    templateUrl: './ltms-download-widget.component.html',
    styleUrls: ['./ltms-download-widget.component.scss'],
    imports: [NgFor, NgIf, NgStyle]
})
export class LtmsDownloadWidgetComponent implements OnInit,AfterViewInit {
  @ViewChild('litmusdownladwidget') litmusdownladwidget!:ElementRef;
  isOpen: boolean = false
  downloadList: any = []
  constructor(private downloadService: DownloadService, private _utilsService: UtilsService, private _router:Router) {
    
  }
  ngOnInit(): void {
    this._router.events.subscribe(()=>{
      this.closeSideBar()
    })
    this.downloadService.showSideBar.subscribe((flag: boolean) => {
      this.isOpen = flag;
    });

    this.downloadService.downloadList.subscribe((list: any) => {
      list.forEach(report => {
        report.time_in_ms= (report.created_date)?moment(report.created_date).valueOf():new Date().getTime();
        report.filename = report.report_name ? report.report_name.split(' ').join('_') + "_" + this.getDateValue() : report.filename;
        report.fileType = report.fileType ? report.fileType : "csv";
      });
      list = _.orderBy(list,['time_in_ms'],['desc']);
      this.downloadList = list
    });

  }

  getDateValue() {
    let currentDate = new Date(),
      day: any = currentDate.getDate(),
      month: any = currentDate.getMonth() + 1,
      year: any = currentDate.getFullYear();
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return day + "_" + month + "_" + year;
  }

  ngAfterViewInit(): void {
    document.addEventListener('click', ( event )=>{
      const elem:any = document.querySelector('.three-dot-container');
      const condition1 = (this.isOpen && this.litmusdownladwidget && this.litmusdownladwidget.nativeElement !== event.target &&  !this.litmusdownladwidget.nativeElement.contains(event.target));
      const condition2 = (elem && elem !== event.target && !elem.contains(event.target))
      if (condition1 && condition2) {  
       this.closeSideBar()
      }
    });
  }
  closeSideBar() {
    // this.isOpen = false;
    this.downloadService.showDownloadSideBar(false)
  }
  removeItem(event:any, item: any) {
    event.stopPropagation();
    this.downloadService.removeDataFromList(item);
  }
  downloadFile(item: any) {
    if (item.dataSource == 'dashboard') {
      let link: any = document.createElement("a");
      link.href = item.uri;
      link.style.visibility = "hidden";
      link.download = item.orignal_filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloadService.removeDataFromList(item)
    }else if(item.temporary_url && item.report_type == "statistics_advanced_download"){
      const url = item.temporary_url;
      window.open(url);
      this.downloadService.removeDataFromList(item)
    }else if(item.temporary_url){
      // var url = window.baseUrl + 'api/infra/download_file?id=' + job._id;
      // const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, 'api/infra/download_file?id=' + item._id);
      const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, '/infra/download_file?id=' + item._id);
      window.open(url);
      this.downloadService.removeDataFromList(item)
    }

  }

  
  // downloadFromJob(job: any) {
  //   if (job.temporary_url) {
  //     // var url = window.baseUrl + 'api/infra/download_file?id=' + job._id;
  //     const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, 'api/infra/download_file?id=' + job._id);
  //     window.open(url);
  //     var idx = _.findIndex(this.downloadList, { '_id': job._id });
  //     this.downloadList.splice(idx, 1);
  //   } else if (job.dataSource == 'dashboard') {
  //     // AnalyticsPrepairDataService.downloadCSVData(job)
  //     // var idx = _.findIndex(this.downloadList, {'_id': job._id});
  //     // _this.reportJobs.splice(idx, 1);
  //   }
  // }
}
